import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";

// ─── Stale-chunk recovery ────────────────────────────────────────────────────
// After a deploy, an old cached index.html may reference JS chunks whose
// hashes no longer exist on the CDN. The browser then throws ChunkLoadError
// and the app renders a blank page. We catch that, purge SW caches and
// hard-reload exactly once so the user lands on the fresh index.html.
(function installChunkErrorRecovery() {
    const RELOAD_FLAG = 'lw_chunk_reloaded_at';
    const onChunkError = (msg) => {
        const text = String(msg || '');
        if (!/ChunkLoadError|Loading chunk|Loading CSS chunk|Failed to fetch dynamically imported module/i.test(text)) return;
        const last = Number(sessionStorage.getItem(RELOAD_FLAG) || 0);
        if (Date.now() - last < 30_000) return; // prevent reload loop
        sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
        // Drop SW caches & unregister, then hard reload.
        const purge = async () => {
            try {
                if ('caches' in window) {
                    const names = await caches.keys();
                    await Promise.all(names.map(n => caches.delete(n)));
                }
                if ('serviceWorker' in navigator) {
                    const regs = await navigator.serviceWorker.getRegistrations();
                    await Promise.all(regs.map(r => r.unregister()));
                }
            } catch (_) { /* noop */ }
            window.location.reload();
        };
        purge();
    };
    window.addEventListener('error', (e) => onChunkError(e?.message || e?.error?.message));
    window.addEventListener('unhandledrejection', (e) => onChunkError(e?.reason?.message || e?.reason));
})();

const store = configureStore({ reducer: rootReducer, devTools: true });

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA (offline support, caching, install prompt)
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Notify PWAInstallPrompt component that an update is waiting
    window.__SW_REGISTRATION__ = registration;
    window.dispatchEvent(new CustomEvent('sw-update-available'));
    window.dispatchEvent(new CustomEvent('sw-update-ready', { detail: registration }));
  },
  onSuccess: (registration) => {
    console.log('[LeadWix] App is ready for offline use.');
  },
});